import DescriptionList from './DescriptionList.vue';
import DescriptionListItem from './DescriptionListItem.vue';

DescriptionList.Item = DescriptionListItem;

export default DescriptionList;
